/*@ngInject*/
const QuoteActionsMediator = function ($rootScope, submissionConstant, quoteActionRepository) {

    this.getQuotesWithEnabledAction = function(quoteId, action){
        return quoteActionRepository.getQuotesWithEnabledAction(quoteId, action);
    };

    this.declineToBind = function (quoteId, primaryReason, comments) {
        return quoteActionRepository.declineToBind(quoteId, primaryReason, comments);
    };

    this.deleteQuote = function (quoteId) {
        return quoteActionRepository.deleteQuote(quoteId);
    };

    this.copyQuote = function (quoteId, proposalId) {
        return quoteActionRepository.copyQuote(quoteId, proposalId);
    };

    this.generateQuote = function (quoteId) {
        return quoteActionRepository.generateQuote(quoteId);
    };

    this.modifyQuote = function (quoteId) {
        return quoteActionRepository.modifyQuote(quoteId);
    };

    this.startQuote = function (quoteId) {
        return quoteActionRepository.startQuote(quoteId);
    };

    this.generateRating = function (quoteIds) {
        return quoteActionRepository.generateRating(quoteIds);
    };

    this.startPricing = function (quoteIds) {
        return quoteActionRepository.startPricing(quoteIds);
    };

    this.modifyPricing = function (quoteId) {
        return quoteActionRepository.modifyPricing(quoteId);
    };

    this.modifyRating = function (quoteId) {
        return quoteActionRepository.modifyRating(quoteId);
    };

    this.beginBinding = function (quoteId) {
        return quoteActionRepository.beginBinding(quoteId);
    };

    this.requestBinding = function (quoteId) {
        return quoteActionRepository.requestBinding(quoteId);
    };

    this.bindQuote = function (proposalId) {
        return quoteActionRepository.bind(proposalId);
    };

    this.generateBinder = function (quoteIds) {
        return quoteActionRepository.generateBinder(quoteIds);
    };

    this.addSectionFromDocument = function (quoteId, attachmentId, displayLabel, sectionType) {
        return quoteActionRepository.addSectionFromDocument(quoteId, attachmentId, displayLabel, sectionType);
    };

    this.addSectionFromFile = function (quoteId, data, file) {
        return quoteActionRepository.uploadSectionFromFile(quoteId, data, file);
    };

    this.unbind = function (quoteId, reason, detail) {
        return quoteActionRepository.unbind(quoteId, reason, detail);
    };

    this.refreshQuoteByIds = function (quoteIds) {
        return quoteActionRepository.refreshQuoteByIds(quoteIds);
    };

    this.modifyBinder = function (quoteId) {
        return quoteActionRepository.modifyBinder(quoteId);
    };

    this.addSection = function (quoteId, sectionTemplateId, sectionType) {
        return quoteActionRepository.addSection(quoteId, sectionTemplateId, sectionType);
    };

    this.deleteSection = function (sectionTemplateId, invalidateProposalDocument) {
        return quoteActionRepository.deleteSection(sectionTemplateId, invalidateProposalDocument);
    };

    this.generateRatingAttachments = function (quoteId, attachmentsToGenerate) {
        return quoteActionRepository.generateRatingAttachments(quoteId, attachmentsToGenerate);
    };

    this.revertToSent = function (quoteId) {
        return quoteActionRepository.revertToSent(quoteId);
    };

    this.withdrawQuote = function (quoteId, reason, detail) {
        return quoteActionRepository.withdrawQuote(quoteId, reason, detail);
    };

    this.withdrawRequest = function (quoteId) {
        return quoteActionRepository.withdrawRequest(quoteId);
    };
};

angular.module('gw-um-submission')
    .service('quoteActionsMediator', QuoteActionsMediator);
